import React, { Suspense } from 'react'
import { Route } from 'react-router-dom'
import { MainHeader } from '../../../global/nav/components/MainHeader'
import { MainLayout } from '../../../global/nav/components/MainLayout'
import { Props } from '../../types'
import SuspenseFallback from '../../../components/layout/SuspenseFallback'

function PartnerRoute({ component: Component, title, ...rest }: Props) {
  return (
    <Route {...rest} render={matchProps => (
      <MainLayout>
        <MainHeader title={title} />
        <Suspense fallback={<SuspenseFallback />}>
          <Component {...matchProps} />
        </Suspense>
      </MainLayout>
    )} />
  )
}

export default PartnerRoute
